import { Emitter, Event } from "../../../features/event-emitter"
import { Company, Request, RequestStatus, useSystemActions } from "../../system"

export const useManagerActions = () => {
    const systemActions = useSystemActions()

    return () => {
        const saveCompany = systemActions().saveCompany

        const resolveRequest = async (
            request: Request,
            company: Company,
            resolution: RequestStatus,
            saveState = true
        ) => {
            const resolvedRequest: Request = {
                ...request as Request,
                status: resolution
            }
            
            const savedRequest = await systemActions(company.id).saveRequest(resolvedRequest, saveState) as Request
            
            Emitter.emit(Event.RESOLVE_REQUEST, savedRequest)
            return savedRequest
        }

        return {
            saveCompany,
            resolveRequest,
        }
    }
}
